import React, { useRef, useState, useCallback } from "react";
import "./barcodeSearch.scss";
import { FiSearch } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import { MdClear } from "react-icons/md";
import { MdQrCodeScanner } from "react-icons/md";
import { Html5QrcodeScanner } from "html5-qrcode";
import { BarcodeSearchProps } from "./interface";

const Index = ({
  searchCallBack,
  placeholder,
  className,
  isClearable = false,
  searchValueLength = 6,
}: BarcodeSearchProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const scannerRef = useRef<any>(null);

  const [showScanner, setShowScanner] = useState(false);
  const [value, setValue] = useState("");

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const trimmed = value.replace(/\s/g, "");

    if (trimmed.length >= searchValueLength) {
      searchCallBack(trimmed);

      if (isClearable) {
        setValue("");
        if (inputRef.current) inputRef.current.value = "";
      }
    }
  };

  const clearInput = () => {
    setValue("");
    if (inputRef.current) {
      inputRef.current.value = "";
      inputRef.current.focus();
    }
  };

  const openScanner = () => setShowScanner(true);

  const initScanner = useCallback((node: HTMLDivElement | null) => {
    if (!node) return;

    const scanner = new Html5QrcodeScanner(
      "barcode-reader",
      { fps: 10, qrbox: 250 },
      false
    );

    let lastScanned = "";
    let lastScanTime = 0;

    scanner.render(
      (decodedText: string) => {
        const now = Date.now();
        if (decodedText === lastScanned && now - lastScanTime < 1000) return;

        lastScanned = decodedText;
        lastScanTime = now;

        setValue(decodedText);
        if (inputRef.current) inputRef.current.value = decodedText;

        searchCallBack(decodedText);
      },
      (err: any) => console.log("Scan error:", err)
    );

    scannerRef.current = scanner;
  }, []);

  const closeScanner = () => {
    setShowScanner(false);

    if (scannerRef.current) {
      try {
        scannerRef.current.clear();
        scannerRef.current = null;
      } catch (err) {
        console.log("Failed to clear scanner:", err);
      }
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="position-relative">
          <span className="position-absolute barcode-search-icon">
            <FiSearch />
          </span>

          <input
            ref={inputRef}
            className={[className, "barcode-search"].join(" ")}
            autoComplete="off"
            type="text"
            name="keyword"
            placeholder={placeholder || "Search"}
            maxLength={6}
            onChange={(e) => setValue(e.target.value)}
          />

          {value !== "" && (
            <button
              type="button"
              className="barcode-clear-btn"
              onClick={clearInput}
            >
              <MdClear />
            </button>
          )}

          <button
            type="button"
            className="barcode-scan-btn d-md-none"
            onClick={openScanner}
          >
            <MdQrCodeScanner />
          </button>
        </div>
      </form>

      {showScanner && (
        <div className="scanner-modal d-md-none">
          <div
            id="barcode-reader"
            ref={initScanner}
            style={{ width: "100%" }}
          ></div>

          <button type="button" onClick={closeScanner}>
            Close
          </button>
        </div>
      )}
    </>
  );
};

export default Index;
